import styled from 'react-emotion';

export default styled('main')`
  flex: 1 1 auto;
`;
